import { User } from '@models/user.model';

export class RoleHelper {
  static roleLevel(role?: string | null): number {
    switch (role) {
      case User.ROLE_ADMIN: {
        return 1;
      }
      case User.ROLE_INSTANCE_CONFIGURATOR: {
        return 2;
      }
      case User.ROLE_CLIENT_ADMIN: {
        return 3;
      }
      case User.ROLE_MARKETER: {
        return 4;
      }
      case User.ROLE_PROPERTY_MANAGER: {
        return 5;
      }
      default: {
        return 6;
      }
    }
  }

  static canEdit(editorRole?: string | null, targetRole?: string | null): boolean {
    return this.roleLevel(editorRole) <= this.roleLevel(targetRole);
  }
}
